const ru = {
  identifyAs: 'Вы идентифицируетесь как....',
  fancyBadges: 'Мы разработали для вас несколько красивых значков',
  selectGender: 'Выберите пол',
  male: 'Мужчина',
  female: 'Женщина',
  gmail: 'Gmail',
  save: 'Сохранить',
};

export default ru;
